<template>
  <div class="bg-white c-gray f-gray sticky-top" id="opc-header">
    <VContainer
      class="d-flex justify-space-between align-center l-spacing-half pb-3 pt-1 pt-sm-3 px-0 px-sm-3"
    >
      <div class="v-col-3">
        <VicampoLink
          id="opc-logo"
          href="/"
          itemscope
          itemtype="https://schema.org/Brand"
          class="flex-col align-center"
        >
          <img :src="logoSrc" class="w-100 h-100" alt="vicampo-logo" />
        </VicampoLink>
      </div>
      <div class="trust d-none d-lg-flex v-col-6 v-col-md-4 v-col-lg-3">
        <SvgWrapper use="icon_svg_money_return" dimensions="40" />
        <div class="pl-1">
          <div class="font-size-s font-weight-bold text-uppercase">
            {{ $t('taste_guarantee') }}
          </div>
          <div class="font-size-xs font-italic">
            {{ $t('refund_subline') }}
          </div>
        </div>
      </div>
      <div
        v-if="freeShipping || !isBundle"
        class="trust d-flex v-col-6 v-col-md-4 v-col-lg-3 pl-0 pl-sm-3 d-flex align-center"
      >
        <SvgWrapper
          use="icon_svg_delivery_free"
          dimensions="40"
          class="flex-shrink-0"
        />
        <div>
          <div class="font-size-s font-weight-bold ml-3 text-uppercase">
            {{
              isBundle ? $t('free_shipping') : $t('opc_single_free_shipping')
            }}
          </div>
          <div
            v-if="isBundle"
            class="font-size-xs font-italic d-none d-sm-block ml-3"
          >
            {{ $t('shipping_subline_opc') }}
          </div>
        </div>
      </div>
      <div class="trust d-none d-md-flex v-col-6 v-col-md-4 v-col-lg-3">
        <SvgWrapper use="icon_svg_phone" dimensions="40" />
        <div class="d-flex flex-column">
          <div id="hotline" class="font-size-s font-weight-bold">
            {{ phoneNumber }}
          </div>
          <div class="font-size-xs font-italic">
            {{ $t('order_on_phone') }}
          </div>
        </div>
      </div>
    </VContainer>
  </div>
</template>

<script>
import logoMain from '@/assets/images/logo-main.svg'
import { useOpcStore } from '@/stores/opc'
import { mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'

const SvgWrapper = defineAsyncComponent(
  () => import('@/components/basic/atoms/SvgWrapper.vue')
)
const VicampoLink = defineAsyncComponent(
  () => import('@/components/basic/atoms/VicampoLink.vue')
)

const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const {
      default: {
        phone: { text: phoneNumber }
      }
    } = await import('@/services/SiteConfig')

    cache = { phoneNumber }
    return cache
  }
})()

export default {
  components: { SvgWrapper, VicampoLink },
  data: () => ({ phoneNumber: '' }),
  computed: {
    ...mapState(useOpcStore, ['stock', 'calculated']),
    isBundle() {
      return this.calculated.isBundle
    },
    freeShipping() {
      return !this.stock.shipping_costs
    },
    logoSrc() {
      return logoMain
    }
  },
  async created() {
    const { phoneNumber } = await _getModules()
    this.phoneNumber = phoneNumber
  }
}
</script>

<style scoped>
#opc-header {
  height: 55px;
}
#opc-logo {
  width: 160px;
  max-width: 100%;
}
.trust {
  align-items: start;
  min-width: 160px;
}
.sticky-top {
  z-index: 4;
}
.display-md-and-up #opc-header {
  height: 75px;
}
.display-md-and-up .trust {
  min-width: 240px;
}
.display-md-and-up #hotline {
  height: 18px;
}
.display-md-and-up #opc-logo {
  min-width: 240px;
}
</style>
